
<div *ngIf="!editing"><span class="float-left">{{ _items ? items[displayValue] : '' }}</span><a class="float-right micro-input-edit-link" id="edit{{editName}}" href="javascript:void(0)" (click)="edit();" *ngIf="allowEditing"><span class="oi oi-pencil oi-smaller"></span> Edit</a>
  <div class="clearfix"></div>
</div>
<div class="input-group" *ngIf="editing">
  <select class="form-control form-control-sm" id="select{{editName}}" [(ngModel)]="editorValue">
    <option *ngFor="let item of _items" [value]="item[0]">{{ item[1] }}</option>
  </select>
  <div class="input-group-append" style="flex-direction: row;">
    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    <button class="btn btn-sm btn-primary" type="button" (click)="save()">Save</button>
  </div>
</div>